import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=5f13fd09&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=ts&"
export * from "./Switcher.vue?vue&type=script&lang=ts&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=5f13fd09&prod&lang=scss&scoped=true&"
import style1 from "./Switcher.vue?vue&type=style&index=1&id=5f13fd09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13fd09",
  null
  
)

export default component.exports